module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (79).fecd8e58.jpg";